// Public business details supplied by the operator; bank fields verified against the PDF.
// The PDF's address belongs to the bank and must never be used as the seller's address.
export const businessProfile = {
  name: 'ИП Благушин Максим Максимович',
  inn: '501502232628',
  ogrnip: '324508100551647',
  phone: '+79153292465',
  phoneLabel: '+7 (915) 329-24-65',
  email: 'blagushin.maksim@yandex.ru',
  address: null,
  bank: 'АО «ТБанк»',
  account: '40802810500006774749',
  bik: '044525974',
  correspondentAccount: '30101810145250000974',
};
